import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router-dom";
import { TableCell, TableHead, TableBody, Table, TableRow, TableFooter, TablePagination } from "@material-ui/core";
import PrivateRoute from "components/PrivateRoute";
import styled from "styled-components";
import { ROUTE_CONTACTS_CHANGE_PASS } from "constants/routes";
import { getContacts, setShouldRefresh, deleteContact } from "store/state/contacts";
import ContactEdit from "./ContactEdit";
import ResetPassword from "./ResetPassword";
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import TablePaginationHelper from "../../../utils/tablePaginationHelper";

const StyledHeaderCell = styled(TableCell)`
  && {
    font-weight: bold;
    font-size: 17px;
    color: black;
    background-color: #fff;
    padding: 10px;
  }
  &&:last-child {
    width: 50%;
  }
`;

const StyledTableRow = styled(TableRow)`
  && {
    height: 24px;
    padding: 0.5em;
    font-size: 17px;
  }
`;

const StyledTableCell = styled(TableCell)`
  && {
    width: 25%;
  }
`;
const BlueTableCell = styled(TableCell)`
  && {
    color: #0000ff;
  }
`;

class ContactTable extends Component {
  // state = {};
  state = {
    orderDir: "asc",
    orderBy: "lastName",
    selected: [],
    data: [], // reserved for sorted list
    isEditingContact: false,
    selectedContactId: null
  };

  tablePaginationHelper = new TablePaginationHelper("b662d317-ae67-4099-874b-10704f4c28b2", 10);

  columns = [
    {
      id: "name",
      numeric: false,
      label: "Name",
      Cell: ({ contact: { firstName, lastName } }) => (
        <StyledTableCell>{firstName} {lastName}</StyledTableCell>
      )
    },
    {
      id: "company",
      numeric: false,
      label: "Company",
      Cell: ({ contact: { companyId, company } }) => (
        <StyledTableCell>{companyId ? company.name : ""}</StyledTableCell>
      )
    },
    {
      id: "city",
      numeric: false,
      label: "City",
      Cell: ({ contact: { city } }) => <TableCell>{city}</TableCell>
    },
    {
      id: "state",
      numeric: false,
      label: "State",
      Cell: ({ contact: { state } }) => <TableCell>{state}</TableCell>
    },
    {
      id: "email",
      numeric: false,
      label: "Email",
      Cell: ({ contact: { email } }) => <BlueTableCell>{email}</BlueTableCell>
    },
    {
      id: "role",
      numeric: false,
      label: "Role",
      Cell: ({ contact: { userId, user } }) => (
        <TableCell>
          {userId && user.roles.length > 0 && this.getRoleDisplayValue(user.roles)}
        </TableCell>
      )
    },
    {
      id: "actions",
      numeric: false,
      label: "Actions",
      actions: true,
      Cell: (contact) => {
        return (
          <TableCell className="contactsActions_TableActions">
            {this.renderOptionsMenu(contact)}
          </TableCell>
        )
      }
    },/*
    {
      id: "actions_del",
      numeric: false,
      label: "Actions",
      actions: true,
      Cell: ({ contact: { id } }) => (
        <TableCell className="contactsActions_TableActions">
          <Button
            onClick={e => this.deleteContact(e, id)}
            className="button_TableActions"
          >
            <DeleteIcon />
          </Button>
        </TableCell>
      )
    },
    {
      id: "resetpassword",
      numeric: false,
      label: "Reset Password",
      actions: true,
      Cell: ({ contact: { id, user } }) =>
      <TableCell className="contactsReset_TableActions">
        {user != null ? (
            <Button onClick={e => this.resetPassword(e, id)} className="button_TableActions">Reset Password</Button>
            ) : <Button onClick={e => this.editContact(e, id)} className="button_TableActions">Set User Role</Button>}
          </TableCell>
    }*/
  ];

  renderOptionsMenu = ({ contact }) => {
    return (
      <OptionsMenu
        options={this.getOptions(contact)}
      />
    )
  }

  getOptions = (contact) => {
    let isAdmin = false;
    if (contact.user && contact.user.roles) {
      let roles = contact.user.roles.map(x => x.role);
      isAdmin = roles.includes("companyAdmin") || roles.includes("systemAdmin");
    }
    if (contact.companyId === this.props.authentication.user.contact.companyId && !isAdmin) {
      return [
        { id: 1, value: "Edit", onClick: (e) => { this.editContact(e, contact.id); } },
        { id: 3, value: "Reset Password", onClick: (e) => { this.resetPassword(e, contact.id); } },
        { id: 4, value: "Delete", onClick: (e) => { this.deleteContact(e, contact.id); } },
      ]
    } else {
      return [
        { id: 1, value: "Edit", onClick: (e) => { this.editContact(e, contact.id); } },
        { id: 3, value: "Reset Password", onClick: (e) => { this.resetPassword(e, contact.id); } },
        { id: 4, value: "Delete", onClick: (e) => { this.deleteContact(e, contact.id); } },
      ]
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { shouldRefresh } = this.props;
    if (shouldRefresh) {
      this.props.getContacts({
        page: this.tablePaginationHelper.page,
        limit: this.tablePaginationHelper.rowsPerPage,
        orderDir: this.state.orderDir,
        orderBy: this.state.orderBy,
      });
      this.props.setShouldRefresh(false);
    }
  }

  getRows = contacts =>
    contacts &&
    contacts.map(contact => (
      <TableRow key={contact.id} hover>
        {this.columns.map(({ id, Cell }) => (
          <Cell key={id} contact={contact} />
        ))}
      </TableRow>
    ));

  getRoleDisplayValue = (roles) => {
    if (roles.length > 1)
      return "Multiple Roles";
    else if (roles.length == 1) {
      const merged = this.mergeRoleLists(roles, this.props.roles);
      return merged[0].displayName;
    }
  }

  mergeRoleLists = (userRoles, systemRoles) => {
    let result = userRoles.map(obj => {
      let data = systemRoles.find(item => item.id === obj.role);
      return { ...obj, ...data }
    });
    return result;
  }

  editContact = (e, contactId) => {
    this.setState({
      isEditingContact: true,
      selectedContactId: contactId
    });
  };

  deleteContact = (e, contactId) => {
    this.props.deleteContact(contactId);
  };

  resetPassword = (e, contactId) => {
    this.props.history.push(
      `/admin/contacts/${contactId}/reset-password`,
      contactId
    );
  };

  handleChangePage = (event, newPage) => {
    if (!event) {
      return null;
    }
    this.tablePaginationHelper.page = newPage;
    this.props.getContacts({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
    });
  };
  handleModalClose = () => {
    this.setState({
      isEditingContact: false,
      selectedContactId: null
    });
  }
  handleChangeRowsPerPage = event => {
    this.props.onChangeRowsPerPage(event);

    this.tablePaginationHelper.rowsPerPage = event.target.value;

    this.props.getContacts({
      page: this.tablePaginationHelper.page,
      limit: this.tablePaginationHelper.rowsPerPage,
      orderDir: this.state.orderDir,
      orderBy: this.state.orderBy,
    });
  };

  render() {
    const rowsPerPage = this.tablePaginationHelper.rowsPerPage;
    const page = this.tablePaginationHelper.page;
    const {
      contacts: { contacts, count },
      authentication: { authed }
    } = this.props;

    return (
      <Fragment>
        <Table paddingnone="true" className="tableBlueHover">
          <TableHead>
            <StyledTableRow>
              <StyledHeaderCell>Name</StyledHeaderCell>
              <StyledHeaderCell>Company</StyledHeaderCell>
              <StyledHeaderCell>City</StyledHeaderCell>
              <StyledHeaderCell>State</StyledHeaderCell>
              <StyledHeaderCell>Email</StyledHeaderCell>
              <StyledHeaderCell>Role</StyledHeaderCell>
              <StyledHeaderCell>Actions</StyledHeaderCell>
              <StyledHeaderCell />
              <StyledHeaderCell />
            </StyledTableRow>
          </TableHead>
          <TableBody>{this.getRows(contacts)}</TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                colSpan={8}
                count={count}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5, 10, 25, 100]}
                page={page}
                backIconButtonProps={{
                  "aria-label": "Previous Page"
                }}
                nextIconButtonProps={{
                  "aria-label": "Next Page"
                }}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                labelDisplayedRows={() => `${page + 1} of ${Math.ceil(count / rowsPerPage)}`}
              />
            </TableRow>
          </TableFooter>
        </Table>

        <ContactEdit
          isEditingContact={this.state.isEditingContact}
          contactId={this.state.selectedContactId}
          handleClose={this.handleModalClose} />

        <PrivateRoute systemAdmin companyAdmin authentication={this.props.authentication} path={ROUTE_CONTACTS_CHANGE_PASS} Component={ResetPassword} />
      </Fragment>
    );
  }
}

const mapStateToProps = ({ authentication, contacts, roles }) => ({
  authentication,
  contacts: contacts.contacts,
  count: contacts.count,
  shouldRefresh: contacts.shouldRefresh,
  roles
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    { getContacts, setShouldRefresh, deleteContact }
  )
)(ContactTable);
